import { Component, OnInit } from '@angular/core';
import { FormBuilder } from "@angular/forms";
import { PortService } from 'src/app/core-services/port.service';
import { Port } from 'src/app/models/Port';
import { AuthService } from 'src/app/core-services/auth.service';
import { Router } from '@angular/router';
import { UserRole, PlanSubcriptions } from 'src/app/Enum/Enum';
import { ToastrService } from 'ngx-toastr';
import { MenuItem } from 'primeng/api';



@Component({
    selector: 'app-inner-header',
    templateUrl: './inner-header.component.html',
    styleUrls: ['./inner-header.component.scss']
})
export class InnerHeaderComponent implements OnInit {

    portsData: Port[] = [];
    portCount: number;
    portName: string;
    submitted: boolean = false;
    isSignedIn: boolean = false;
    userName: string;
    loggedInUser: any;
    isAdmin: boolean;
    items: MenuItem[];
    user: MenuItem[];
    templateType: number;
    templateName: string;
    isSubcription: number;
    planId: number;
    userId: number;
    


    constructor(private fb: FormBuilder, private portService: PortService, private authenticationService: AuthService, private router: Router, private toastr: ToastrService) {
        // this.items = [
        //     { label: 'IMPORT SCHEDULE CSV', routerLink: ['/importschedulecsv'] },
        //     { label: 'PORTS', routerLink: ['/ports'] },
        //     { label: 'VESSELS', routerLink: ['/vessels'] },
        //     { label: 'USERS', routerLink: ['/users'] },
        //     { label: 'PLANS', routerLink: ['/plans'] }
        // ];
        var currentUser = localStorage.getItem('currentUser');
        if (currentUser != null && currentUser != undefined) {
            this.isSignedIn = true;
            this.loggedInUser = JSON.parse(currentUser);
            if (this.loggedInUser != null && this.loggedInUser.usersDetailsVM != null) {
                this.userName = this.loggedInUser.usersDetailsVM.firstName + ' ' + this.loggedInUser.usersDetailsVM.lastName;
                this.isSubcription = this.loggedInUser.usersDetailsVM.planSub;
                this.planId = this.loggedInUser.usersDetailsVM.planId;
                this.userId = this.loggedInUser.usersDetailsVM.id;
                if (this.loggedInUser.usersDetailsVM.userRole != null && this.loggedInUser.usersDetailsVM.userRole != '') {
                    if (this.loggedInUser.usersDetailsVM.userRole == UserRole.SuperAdmin) {
                        this.isAdmin = true;
                    }
                }
            }
        }

        // this.user = [
        //     // {label: 'MY PROFILE', routerLink: ['/profile']},
        // { label: this.userName, routerLink: ['/profile'] },
        //     { label: 'PLAN SELECTION', routerLink: ['/planselection'] },
        //     { label: 'SIGN OUT', command: (event: Event) => { this.signOut() } }
        // ];
    }
    myForm(templateType) {
    }


    ngOnInit() {
        if (this.templateType === 3) {
            this.templateName = '';
        }
        if (this.templateType === 3) {
            this.templateName = 'Site Diary';
        }

    }
    signOut() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }
    planSubcriptiont(status) {
        if(this.planId > 0 && this.userId > 0 && status > 0)
        {
            this.authenticationService.subcriptionPlan(this.planId, this.userId).subscribe((response: any) => {
                if(response != null && response.content != null)
                {
                    if(response.content == true)
                    {
                        this.isSubcription = status;
                        if(this.isSubcription == 3)
                        {
                            this.toastr.info('Plan is subscribed successfully  ','Info');
                        }
                        else {
                            this.toastr.info('Plan is unsubscribed successfully','Info');
                        }
                        if(PlanSubcriptions.Active == status)
                        {
                            this.isSubcription = PlanSubcriptions.Suspended;  
                            this.loggedInUser.planSub =PlanSubcriptions.Suspended;  ;
                        }
                        else if(PlanSubcriptions.Suspended)
                        {
                            this.isSubcription = PlanSubcriptions.Active;  ;  
                            this.loggedInUser.planSub =PlanSubcriptions.Active;  ;
                        }

                        localStorage.setItem("currentUser", JSON.stringify(this.loggedInUser));                   
                    }
                    else {
                        this.toastr.error('Something wrong','Error');
                    }
                }
            });
        }
    }

}
